// Swatch swap images start as loading="lazy" and sit under opacity:0/visibility:hidden
// until a swatch is picked, so the browser often never prioritizes fetching them.
// Force them to load as soon as they're revealed instead of leaving them stuck
// behind the "is-loading" placeholder.
function forceLoadRevealedImages(container) {
  if (!container) return;

  container.querySelectorAll("img").forEach((img) => {
    if (img.loading === "lazy") {
      img.loading = "eager";
    }

    if (img.complete) {
      img.classList.remove("is-loading");
      img.parentNode?.classList.remove("is-loading");

      if (img.parentNode?.parentNode?.classList.contains("is-loading")) {
        img.parentNode.parentNode.classList.remove("is-loading");
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".flickity-page-dots, .flickity-button")) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }

    const swatch = e.target.closest(".color-available .swatch-element");
    if (!swatch) return;

    const allSwatches =
      swatch.parentElement?.querySelectorAll(".swatch-element");
    if (allSwatches) {
      allSwatches.forEach((el) => el.classList.remove("active"));
    }
    swatch.classList.add("active");

    const loc = swatch.dataset.bg || "";
    const vari = swatch.dataset.value || "";
    const cls = swatch.dataset.productId || "";
    const variantId = swatch.dataset.variantId || "";
    const colorHandle = swatch.dataset.swatchColorHandle || "";
    const price = swatch.dataset.price || "";
    const oldPrice = swatch.dataset.oldPrice || "";
    const getUrl = swatch.dataset.url || "";

    const productInfo = swatch.closest(".product-information");
    if (productInfo) {
      const titleEl = productInfo.querySelector(".varaint_title");
      if (titleEl) titleEl.innerHTML = vari;

      const priceEl = productInfo.querySelector(".main_price");
      if (priceEl) {
        if (price !== "") {
          if (oldPrice !== "") {
            const oldSpan = `<span class="old-price" style="margin: 0;">${oldPrice}</span>`;
            priceEl.innerHTML = `From ${oldSpan} ${price}`;
          } else {
            priceEl.innerHTML = `From ${price}`;
          }
        }
      }
    }

    // The same product can render more than once per page (tabbed collections,
    // multiple product sliders, upsells), so a page-wide class lookup would
    // update the first copy instead of the card that was actually clicked.
    const main = swatch.closest(".product-item." + CSS.escape(cls));
    if (main) {
      main.setAttribute("data-bgset", loc);

      const bgInners = main.querySelectorAll(".product-item__bg__inner");
      bgInners.forEach((el) => el.classList.remove("is-visible"));

      // Prefer matching by swatch color (shows only images of the selected color,
      // like the product page) - fall back to the representative variant id if
      // this product/option couldn't be matched to a color for any reason.
      const visibleEl = colorHandle
        ? main.querySelector(`.product-item__bg__inner[data-swatch-color="${CSS.escape(colorHandle)}"]`)
        : main.querySelector(".product-item__bg__inner." + CSS.escape(variantId));
      if (visibleEl) {
        visibleEl.classList.add("is-visible");
        forceLoadRevealedImages(visibleEl);
      }

      // Flickity only moves matched cells (initially just the default
      // material, per the Liquid-rendered class) into its generated
      // ".flickity-slider" wrapper - other materials' "-pending" slides are
      // never inside it, they stay as direct children of [data-hover-slider]
      // (the flickity-enabled element itself). Scope the slide cache there,
      // not to ".flickity-slider", or other materials can never be found.
      const sliderContainer = main.querySelector("[data-hover-slider]");
      if (sliderContainer) {
        // Cache the full slide list (both already-active ones and other
        // materials' slides still marked "-pending" from the Liquid render)
        // once per product card, so re-filtering on later swatch clicks always
        // starts from every slide, even after Flickity cells have been
        // removed/appended.
        if (!sliderContainer._swatchAllSlides) {
          sliderContainer._swatchAllSlides = Array.from(
            sliderContainer.querySelectorAll(
              ".product-item__bg__slide, .product-item__bg__slide-pending"
            )
          );
        }
        const allSlides = sliderContainer._swatchAllSlides;

        const matchingSlides = colorHandle
          ? allSlides.filter((slide) => slide.dataset.swatchColor === colorHandle)
          : allSlides.filter((slide) => slide.classList.contains(variantId));
        const slidesToShow = matchingSlides.length ? matchingSlides : allSlides;

        // Promote this material's slides to the real Flickity cell class -
        // only the material active by default carries it from the server
        // render, everything else starts as "-pending" (display:none) until
        // it's actually picked.
        slidesToShow.forEach((slide) => {
          slide.classList.remove("product-item__bg__slide-pending");
          slide.classList.add("product-item__bg__slide");
        });

        const flkty =
          window.theme && window.theme.Flickity
            ? window.theme.Flickity.data(sliderContainer)
            : null;

        slidesToShow.forEach((slide) => forceLoadRevealedImages(slide));

        if (flkty) {
          flkty.remove(flkty.getCellElements());
          flkty.append(slidesToShow);
          flkty.select(0, false, true);
        } else {
          allSlides.forEach((slide) => {
            slide.hidden = !slidesToShow.includes(slide);
          });
        }
      }

      const variantTitleEl = main.querySelector(".variant-option-title");
      if (variantTitleEl) variantTitleEl.innerHTML = vari;
    }

    const productItem = swatch.closest(".product-item");
    if (productItem && getUrl !== "") {
      const links = productItem.querySelectorAll("a");
      links.forEach((a) => a.setAttribute("href", getUrl));
    }
  });
});

const initCollectionFilters = () => {
  const filterButtons = document.querySelectorAll(".btn-filter");
  const collectionFiltersForm = document.querySelector("collection-filters-form");
  const viewAllButton = document.querySelector(".btn-view-all");
  viewAllButton?.classList.add("active");

  if (!filterButtons.length || !collectionFiltersForm) return;

  // Check and set active state based on checked checkboxes
  const checkedCheckboxes = document.querySelectorAll(
    '.collection-nav.filter-by-metafields input[type="checkbox"]:checked'
  );

  if (checkedCheckboxes.length === 0) {
    // No checkboxes selected → activate "View All"
    viewAllButton?.classList.add("active");
    filterButtons.forEach((button) => {
      if (!button.classList.contains("btn-view-all")) {
        button.classList.remove("active");
      }
    });
  } else {
    // Some checkboxes selected → deactivate "View All"
    viewAllButton?.classList.remove("active");
    filterButtons.forEach((button) => {
      if (!button.classList.contains("btn-view-all")) {
        const filterValue = button.textContent.trim();
        const checkbox = Array.from(checkedCheckboxes).find((cb) => {
          const label = cb.nextElementSibling;
          return label && label.textContent.trim() === filterValue;
        });
        button.classList.toggle("active", checkbox !== undefined);
      }
    });
  }

  // Handle "View All" click → uncheck all checkboxes
  if (viewAllButton) {
    viewAllButton.addEventListener("click", function () {
      const checkboxes = document.querySelectorAll(
        '.collection-nav.filter-by-metafields input[type="checkbox"]'
      );

      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          checkbox.click();
        }
      });

      filterButtons.forEach((button) => button.classList.remove("active"));
      this.classList.add("active");
    });
  }

  // Handle individual filter button clicks (multi-select enabled)
  filterButtons.forEach((button) => {
    if (button.classList.contains("btn-view-all")) return;

    button.addEventListener("click", function () {
      const filterValue = this.textContent.trim();
      const checkboxes = document.querySelectorAll(
        '.collection-nav.filter-by-metafields input[type="checkbox"]'
      );

      const matchedCheckbox = Array.from(checkboxes).find((checkbox) => {
        const label = checkbox.nextElementSibling;
        return label && label.textContent.trim() === filterValue;
      });

      if (!matchedCheckbox) return;

      // Toggle checkbox state
      matchedCheckbox.click();

      // Toggle button active state
      this.classList.toggle("active");

      // If no checkboxes are selected → reactivate "View All"
      const anyChecked = document.querySelectorAll(
        '.collection-nav.filter-by-metafields input[type="checkbox"]:checked'
      ).length > 0;

      if (viewAllButton) {
        viewAllButton.classList.toggle("active", !anyChecked);
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", function () {
  initCollectionFilters();
  const readMoreHandler = initReadMore();
  document.addEventListener("click", readMoreHandler);
});

function initReadMore() {
  // Initialize state for all existing elements
  const readMoreWrappers = document.querySelectorAll(".read-more-wrapper");
  readMoreWrappers.forEach((wrapper) => {
    const content = wrapper.querySelector(".read-more-content-container");
    const button = wrapper.querySelector(".read-more-btn");

    if (!content || !button) return;

    const textLength = content.textContent.trim().length;
    const maxChars = 250;

    // Check if text is longer than maxChars
    if (textLength > maxChars) {
      // Add collapsed class if not exists
      if (!content.classList.contains("collapsed")) {
        content.classList.add("collapsed");
      }

      // Show button
      button.style.display = "block";
    } else {
      // Remove collapsed and expanded classes
      content.classList.remove("collapsed", "expanded");

      // Hide button
      button.style.display = "none";
    }
  });

  // Return the event listener function
  return function (event) {
    const button = event.target.closest(".read-more-btn");
    if (!button) return;

    const wrapper = button.closest(".read-more-wrapper");
    const content = wrapper.querySelector(".read-more-content-container");
    if (!content) return;

    const textLength = content.textContent.trim().length;
    const maxChars = 250;

    // Only handle if text is longer than maxChars
    if (textLength > maxChars) {
      if (content.classList.contains("collapsed")) {
        content.classList.remove("collapsed");
        content.classList.add("expanded");
        button.textContent = "Read less";
      } else {
        content.classList.remove("expanded");
        content.classList.add("collapsed");
        button.textContent = "Read more";
      }
    }
  };
}

// Product media videos use native <video controls> replaced by a custom
// play/pause toggle: iOS/Android native controls dim + auto-hide on their own
// OS timer (2-3s) which can't be tuned via CSS, so we drive the fade ourselves
// via the "is-visible" class for a fast, consistent ~0.5s flash on every device.
function initProductVideoToggles(root) {
  const VISIBLE_DURATION = 500;

  (root || document)
    .querySelectorAll("[data-video-toggle]")
    .forEach((toggle) => {
      if (toggle.dataset.bound) return;
      toggle.dataset.bound = "true";

      const container = toggle.closest("deferred-media");
      if (!container) return;

      let hideTimer;
      const flashToggle = () => {
        clearTimeout(hideTimer);
        toggle.classList.add("is-visible");
        hideTimer = setTimeout(() => {
          toggle.classList.remove("is-visible");
        }, VISIBLE_DURATION);
      };

      const syncState = (event) => {
        toggle.setAttribute(
          "data-state",
          event.target.paused ? "paused" : "playing"
        );
        flashToggle();
      };

      container.addEventListener(
        "click",
        (event) => {
          if (!container.hasAttribute("loaded")) return;
          if (event.target.closest("[data-deferred-media-button]")) return;

          const video = container.querySelector("video");
          if (!video) return;

          event.preventDefault();
          video.paused ? video.play() : video.pause();
        },
        true
      );

      container.addEventListener("play", syncState, true);
      container.addEventListener("pause", syncState, true);
    });
}

document.addEventListener("DOMContentLoaded", () =>
  initProductVideoToggles(document)
);
document.addEventListener("shopify:section:load", (event) =>
  initProductVideoToggles(event.target)
);
// Fired after a color-swatch change replaces <product-images> wholesale
// (see updateProductImage() in theme.dev.js) - the fresh nodes it swaps in
// need their toggle listeners bound again from scratch.
document.addEventListener("theme:product:images-updated", () =>
  initProductVideoToggles(document)
);
